import { render, staticRenderFns } from "./VendorsViewChart.vue?vue&type=template&id=799f15ff"
import script from "./VendorsViewChart.vue?vue&type=script&lang=js"
export * from "./VendorsViewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports